import { useState } from "react";
import Listado from "./Listado";
import ConsultarAsignar from "../financiero/ConsultarAsignar";
import PermisosUsuario from "./PermisosUsuario";
import { useSession } from "@/context/SessionProvider";

const MANAGE_ROLES = new Set([1]);

export default function TabsPerfil() {
    const { user } = useSession();
    const canManage = MANAGE_ROLES.has(Number(user?.perfil_id));

    const [activeTab, setActiveTab] = useState("Dar de alta");

    // Tabs base
    const baseTabs = ["Dar de alta", "Consultar y asignar"];

    // Agregar "Permisos" solo si el usuario puede administrar
    const tabs = canManage ? [...baseTabs, "Permisos"] : baseTabs;

    return (
        <div className="p-6">
            <div className="border-b border-gray-200 flex space-x-6 mb-6">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`pb-2 text-sm font-medium transition-colors duration-150 ${activeTab === tab
                                ? "text-blue-900 border-b-2 border-blue-900"
                                : "text-gray-600 hover:text-blue-800"
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {activeTab === "Dar de alta" && <Listado />}
            {activeTab === "Consultar y asignar" && <ConsultarAsignar />}
            {activeTab === "Permisos" && canManage && <PermisosUsuario />}
        </div>
    );
}